"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Image = function Image(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var iconSize = size === 'original' ? 'width="48" height="48"' : 'width="100%"';
  var title = 'Image Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ").concat(iconSize, " viewBox=\"0 0 48 48\">\n      <title>").concat(title, "</title>\n      <path fill=").concat(color, " d=\"M9.25 42.7q-1.6 0-2.775-1.175Q5.3 40.35 5.3 38.75V9.25q0-1.65 1.175-2.825Q7.65 5.25 9.25 5.25h29.5q1.65 0 2.825 1.175Q42.75 7.6 42.75 9.25v29.5q0 1.6-1.175 2.775Q40.4 42.7 38.75 42.7Zm2.2-8.3H36.6l-7.7-10.45-6.6 8.55-4.65-6.35Z\"/>\n    </svg>\n  ");
};

var _default = Image;
exports["default"] = _default;